export const REPORT_BY_ID = (id) => `/attendance/student/attendances/${id}`;
export const PLAN = "/v2/plans";
export const ACTIVITY = "/v2/current-plan/activity";
export const ACTIVITIES = "/v2/current-plan/activities";
export const EXECUTION = "/v2/executions/activities";
export const ACTIVITY_BY_ID = (id) => `/v2/current-plan/activity/${id}`;
export const EXECUTION_BY_ID = (id) => `/v2/current-plan/execution/${id}`;